import { useLocation } from 'react-router';

export const useAfterLoggedInTarget = () => {
  const location: any = useLocation();
  if (typeof location.state === 'object' && location.state) {
    return location.state.afterLoggedInTarget;
  }
  return null;
};
